"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImpressionEventComponente = exports.AppReadyEventComponente = exports.updateComponent = exports.sendReadyEvent = exports.sendClickEvent = exports.getRelatedElements = void 0;
const React = __importStar(require("react"));
const defaultAttributes = {
    componentName: "",
    label: "",
    targetURL: "",
    clickID: "",
    elementName: "",
    value: "",
    pos: "",
};
const defaultEventInfos = {
    eventAction: "",
    eventName: "",
};
const getRelatedElements = (elementName, elementValues) => {
    return elementValues
        .filter((x) => x !== undefined)
        .map((elementValue) => ({
        elementName,
        elementValue,
    }));
};
exports.getRelatedElements = getRelatedElements;
const sendClickEvent = (trackingService, eventInfo, attributes) => {
    const clickEvent = {
        event: {
            eventInfo: Object.assign(Object.assign({}, defaultEventInfos), eventInfo),
            attributes: Object.assign(Object.assign({}, defaultAttributes), attributes),
        },
    };
    trackingService.track(clickEvent);
};
exports.sendClickEvent = sendClickEvent;
const sendReadyEvent = (trackingService, featureAppName) => {
    const readyEvent = {
        event: {
            eventInfo: {
                eventAction: "feature_app_ready",
                eventName: `${featureAppName} - feature app ready`,
            },
            attributes: Object.assign(Object.assign({}, defaultAttributes), { componentName: featureAppName }),
        },
    };
    trackingService.track(readyEvent);
};
exports.sendReadyEvent = sendReadyEvent;
const updateComponent = (trackingService, featureAppVersion, partnerId) => {
    const componentUpdate = {
        attributes: {
            implementer: 2,
            version: featureAppVersion,
        },
        dealer: {
            dealerInfo: {
                dealerID: partnerId,
            },
        },
    };
    trackingService.updateComponent(componentUpdate);
};
exports.updateComponent = updateComponent;
const registerImpressionTracking = (element, trackingService, featureAppName, relatedElements, value) => {
    const impressionEvent = {
        event: {
            attributes: Object.assign({ componentName: featureAppName, value: value || "" }, (relatedElements && { relatedElements })),
            eventInfo: {
                eventAction: "impression",
                eventName: `${featureAppName} - impression`,
            },
        },
    };
    const dataCallback = () => {
        return impressionEvent;
    };
    trackingService.registerImpressionTracking(element, dataCallback);
};
const AppReadyEventComponente = ({ partnerId, featureAppName, trackingService, featureAppVersion }) => {
    React.useEffect(() => {
        // eslint-disable-next-line no-param-reassign
        trackingService.featureAppName = featureAppName;
        (0, exports.updateComponent)(trackingService, featureAppVersion, partnerId);
        (0, exports.sendReadyEvent)(trackingService, featureAppName);
    }, [featureAppName, featureAppVersion, partnerId, trackingService]);
    return React.createElement("div", { "data-testid": "appready event" });
};
exports.AppReadyEventComponente = AppReadyEventComponente;
const ImpressionEventComponente = ({ relatedElements, featureAppName, trackingService, value }) => {
    const ref = React.useRef(null);
    const refRelatedElements = React.useRef(relatedElements);
    React.useEffect(() => {
        if (ref.current) {
            registerImpressionTracking(ref.current, trackingService, featureAppName, refRelatedElements.current, value);
        }
    }, [featureAppName, refRelatedElements, trackingService]);
    return React.createElement("div", { ref: ref, "data-testid": "impression event" });
};
exports.ImpressionEventComponente = ImpressionEventComponente;
exports.AppReadyEventComponente.defaultProps = { partnerId: undefined };
//# sourceMappingURL=tracking-manager-v2.js.map